import './DesktopStyle3.scss';

const DesktopStyle3 = ({ children }: { children: JSX.Element }) => {
  return children;
};

export default DesktopStyle3;
